import template from "./form-preview.html";
import {formPreviewController} from "./form-preview.controller.js";
import "./form-preview.scss";

export const formPreviewComponent = {
    template,
    controller: formPreviewController,
    controllerAs: "form",
    bindings: {
        definedInputs: "<",
        customInputs: "<",
        checkboxes: "<",
        signature: "<",
        oneAnswer: "<",
        enabled: "<"
    }
};


// WEBPACK FOOTER //
// ./sources/components/common/forms-preview/form-preview.component.js